/** @format */

import { createGlobalStyle } from "styled-components";
import { COLORS, WEIGHTS } from "../../constants";

const GlobalStyles = createGlobalStyle`
*, *::before, *::after {
  box-sizing: border-box;
}

* {
  margin: 0;
  ${"" /* cursor: none; */}
}

html{
  scrollbar-width: thin;
  --reach-dialog: 1;
}


html, body {
  height: 100%;
}

body {
  line-height: 1.1;
  -webkit-font-smoothing: antialiased;
  font-family: "Helvetica Neue", "Fallback", sans-serif;

  --color-primary: ${COLORS.red};
  --color-offwhite: ${COLORS.offwhite};
  --color-white: ${COLORS.white};
  --color-grey: ${COLORS.grey};
  --color-ash: ${COLORS.ash};
  --color-dark-100: ${COLORS.dark[100]};
  --color-dark-300: ${COLORS.dark[300]};
  --color-dark-500: ${COLORS.dark[500]};
  --color-dark-700: ${COLORS.dark[700]};
  --color-lavendar: ${COLORS.lavendar};
  --color-yellow: ${COLORS.yellow};
  --color-green: ${COLORS.green};
  --color-blue: ${COLORS.blue};
  --color-salsa: ${COLORS.salsa};
  
  --weight-light: ${WEIGHTS.light};
  --weight-regular: ${WEIGHTS.regular};
  --weight-medium: ${WEIGHTS.medium};
  --weight-bold: ${WEIGHTS.bold};
  --weight-black: ${WEIGHTS.black};
  background-color: var(--color-offwhite);
}

::-webkit-scrollbar {
    width: 10px;
    background-color: var(--color-primary);
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 1000px;
    background-color: var(--color-offwhite);
    border: 2px solid var(--color-primary);
  }
  ::-webkit-scrollbar-thumb:hover {
    background-color: var(--gray-500);
  }

img, picture, video, canvas, svg {
  display: block;
  width: 100%;
}

input, button, textarea, select {
  font: inherit;
}

p, h1, h2, h3, h4, h5, h6 {
  overflow-wrap: break-word;
}

h1{
  font-size: clamp(
    3.75rem,
    10vw + 1.7rem,
    10rem
  );
  display: inline-block;
  font-weight: 900;
  font-stretch: condensed;
  text-transform: uppercase;
}

h2{
  font-size: clamp(
    1.5rem,
    2.5vw + 0.95rem,
    2.7rem
  );
  font-weight: 700;
}

h3{
  font-size: 2.5rem;
  font-weight: 700;
  font-stretch: condensed;
}

h4{
  font-size: 1.5rem;
  font-weight: 700;
}

h5{
  font-size: 1rem;
  font-weight: 300;
}

p{
  font-size: 1.125rem;
  font-weight: 400;
}

.cursor {
  background-color: #111;
  height: 50px;
  width: 50px;
  border-radius: 50%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999;
  pointer-events: none;
}

#root, #__next {
  isolation: isolate;
}
`;

export default GlobalStyles;
